// extracted by mini-css-extract-plugin
export default {"title":"E0jK9","mobile":"Sf7_w"};